<template>
  <div class="root">
    <div class="word-extract">
      <el-form class="form-box-validate" ref="form" label-width="160px">
        <el-form-item label="选择文件类型：">
          <el-select v-model="form.fileType" placeholder="请选择文件类型" :filterable="true" :clearable="true">
            <el-option label="2层目录结构" :value="1" />
            <el-option label="3层目录结构" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="上传文件：">
          <el-button class="upload-btn" :loading="loading || false" :size="`medium`" type="primary" :plain="false" :round="false" icon="el-icon-upload">
            <span>请上传 Excel 文件</span>
            <input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="change($event)">
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "word-extract",
  data() {
    return {
      loading: false,
      form: { fileKey: "", fileType: 2 },
    };
  },
  mounted() {
    this.$bus.$emit("ready");
  },
  methods: {
    /**
     * @description 上传方法
     * @param {Object} e
     * @param {String} id 针对身份证模式，id指当前是哪张Id
     * @param {Number} index 针对身份证模式，index指当前是哪张索引
     */
    change(e, id, index) {
      let files = e.target.files;
      let file = files[0];

      const fileReg = "(xls|xlsx)$";
      const limit = 20;

      // excel word 等 使用 name 的后缀判断格式
      let fileSuffix = file.name.split("").reverse().join("").split(".")[0].split("").reverse().join("").toLowerCase();

      if (!new RegExp(fileReg, "gi").test(fileSuffix)) {
        let errorTxt = `文件格式错误 当前文件格式 ${fileSuffix}`;
        this.$message({ message: errorTxt, type: "error" });
        return false;
      }

      if (file.size > limit * 1024 * 1024) {
        this.$message({ message: `上传文件大于 ${limit} MB`, type: "error" });
        return false;
      }

      this.uploadFileCall(file);

      // 清空当前上传组件的值，确保可以重复选择
      e.target.value = "";
    },

    /**
     * @description 上传文件
     * @param {String} file 上传的文件
     */
    uploadFileCall(file) {
      let loading = this.$loading({ text: "处理中..." });

      let data = {
        type: this.form.fileType,
        fileType: file.name,
      };

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        data.fileData = reader.result;

        this.$ajax({
          url: "/api/file/upOssFile",
          method: "post",
          data,
        }).then((rs) => {
          loading.close();

          // 下载
          this.$ajax({
            url: "/api/file/downOssFile",
            method: "post",
            data: { fileName: rs.data.data.fileKey },
          }).then((td) => {
            var a = document.createElement("a");
            a.setAttribute("href", td.data.data);
            a.setAttribute("target", "_blank");
            a.setAttribute("id", "link-temp");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(document.getElementById("link-temp"));
          });
        });
      };
    },
  },
};
</script>
<style lang="less" scoped>
@import "..\..\..\global\css\mixin\mixin.less";
.word-extract {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: block;
  background: #fff;
  overflow: hidden;

  .form-box-validate {
    width: 600px;
    margin: 50px auto;

    .upload-btn {
      position: relative;

      input[type="file"] {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// wordExtract.vue?49d97209